import React from 'react'
import EligiblitySteps from '../../components/application/eligibility'

function Eligiblity() {
  return (
    <EligiblitySteps/>
  )
}

export default Eligiblity